import React, {useEffect, useRef} from "react";
import Api from "../../fetchs/Api";
import Modals from "../../componentesHTML/componentesSecundarios/Modals";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import latinize from 'latinize';
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorAreasGeograficas(parametros){
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
  const idrefCuadro = useRef([]);
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
      var_ingles = "en";
  }
  const registradatos = ((TITULO,URL,metodoBusqueda) => {
      TITULO= TITULO.replace(/['°|@_=¿?¡!:/<~>()&%#*;+-.,?^${}[()]|[\]\\]/g, " ");
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "2",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO.replace(/['°|@_=¿?¡!:/<~>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
function LlamarComponenteAreaGeo(areaGeograficaValor, idDiv, idioma, cveMpio, cveEntVar, mpioVar, entVar) {
  let parametros = {
          "tematica": "0",
          "ind": "203932", // indicador
          "lang": idioma, // idioma
          "ag": areaGeograficaValor, // area geografica
          "tc": "13v2", // tipo de cuadro
          "mn": false, // mostrar notas
          "mf": false, // mostrar fuente
          areaSeleccionada: { cveMpio: cveMpio, cveEnt: cveEntVar, mpio: mpioVar, ent: entVar }
      }
  let c = new CuadroComponente();
  c.GeneraCuadro(parametros, idDiv);
}
function LlamarComponenteAreaGeoLocalidades(areaGeograficaValor, idDiv, idioma) {
  let parametros = {
    ag: areaGeograficaValor, // clave localidad
    lang: idioma, //idioma
    tc: "18", // tipo de cuadro / ficha
    secc: "1,2,3,4", // secciones a mostrar
    mbe: false // exportación
  }
   let c = new CuadroComponente();
   c.GeneraCuadro(parametros, idDiv);
}
const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:/<>(~)&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (const word of textInputAux) {
          concatena.push(`${word}`); 
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest}
                    sanitize={sanitizeText}
                /> 
        );
    }
    const sanitizeText = (text) => {
        return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
  if (parametros.coleccionTodo != "Todo") {
    let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
    const param = {
    busqueda: parametros.textoBusqueda,
    busquedaCiencia: "",
    paginaInicio: parametros.pageInicial,
    paginaFin: parametros.pageFin,
    filtroAreaGeo: "",
    filtrobusqueda: parametros.camposBuscador,
    orderby: parametros.camposOrden,
    orderbyAscDesc: parametros.ordenamiento,
    metodoBusqueda: parametros.metodoBusqueda
  };
  const apiData = Api("/app/api/buscadorcore/v1/busquedaAreasGeograficas/", param);
    function RegistraBus(data){
      if(data.length > 0)
        ApiInsertarBusqueda(parametros.textoBusqueda ,"2", data[0].TOTAL, metodo);
      else
        ApiInsertarBusqueda(parametros.textoBusqueda ,"2", 0, metodo);
    }
  useEffect(() => {
    if (parametros.coleccionTodo != "Todo") {
      if (!apiData.loading){
        RegistraBus(apiData.data)
      }
      if(apiData.data.length > 0) {
        apiData.data.forEach(element => {
          if (idrefCuadro.current[element.ID] != null ) {
            if (element.PRIORIDAD !== 3){
              let entidade = element.TITULO.split(",");
              let mpioVar = entidade[0];
              let entVar = entidade[1];
              LlamarComponenteAreaGeo(element.UBICACION_GEOGRAFICA, 'nivel2-1-' +  element.ID, var_ingles, element.UBICACION_GEOGRAFICA, element.UBICACION_GEOGRAFICA.substring(0, 2), mpioVar, entVar)
            }
            else{
              LlamarComponenteAreaGeoLocalidades(element.UBICACION_GEOGRAFICA, 'nivel2-1-' + element.ID, var_ingles)
            }
          }
        });
        document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
        _updateTotalDatos({totalDatos:apiData.data[0].TOTAL});
      }else{
        _updateTotalDatos({totalDatos:0});
      }
    }
  },[apiData.data]);
  return(
      <>
      {
        apiData.loading? <Modals />:
          !apiData.loading && apiData.data.map((datos,i) => (
            <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorAeasGeograficas-" + i} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + i}>
                
                <div  style={{paddingLeft: "0px",bottom:"5px"}} id={"titulo-" + i}>
                  <a target="_blank" href={"/app/mapa/espacioydatos/default.aspx?ag=" + datos.UBICACION_GEOGRAFICA} id={"TituloHiper-0" + i}>
                    <span className="goog-trans-section l tit-normal espacios" id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO, "/app/mapa/espacioydatos/default.aspx?ag=" + datos.UBICACION_GEOGRAFICA, parametros.metodoBusqueda)}> 
                      {highlightTexto(datos.TITULO + " (" + datos.UBICACION_GEOGRAFICA +")")}
                    </span>
                    <img src="/componentes/biinegi/img/icomapar.png" className="icoES" id="magen" alt="" />
                  </a>
                </div>
                <div className="col-lg-12" id="responsivaAreas">
                  <div className="row">
                    <div className="col-lg-6" style={{marginTop:"10px"}} id={"nivel1-" + i}>
                        <img src={"/img/servicios/agmapas/" + datos.UBICACION_GEOGRAFICA + ".jpg"}  className="mx-auto imgMax" id={"img-" + i} alt="" />
                    </div>
                    <div className="col-xs-12 col-lg-6 col-sm-12 col-md-11 topAreas" id={"nivel2-" + i}>
                      <div id={"nivel2-1-" + i} ref={(el) => (idrefCuadro.current[i] = el)}>
                      </div>
                    </div>
                  </div>
                </div>
                
                
            </div>
          ))
      }
      </>
    );
  }
  else{
    let datos= parametros.datos;
    let id= parametros.id;
    let metodo= parametros.metodo;
    useEffect(() => {
        if (idrefCuadro.current[id] != null ) {
            if (datos.PRIORIDAD !== 3){
              let entidade = datos.TITULO.split(",");
              let mpioVar = entidade[0];
              let entVar = entidade[1];
              LlamarComponenteAreaGeo(datos.UBICACION_GEOGRAFICA, 'nivel2-1-' +  id, var_ingles, datos.UBICACION_GEOGRAFICA, datos.UBICACION_GEOGRAFICA.substring(0, 2), mpioVar, entVar)
            }
            else{
              LlamarComponenteAreaGeoLocalidades(datos.UBICACION_GEOGRAFICA, 'nivel2-1-' + id, var_ingles)
            }
        }
    },[datos]);
  return(
        <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorAeasGeograficas-" + id} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + id}>
          <div  style={{paddingLeft: "0px",bottom:"5px"}} id={"titulo-" + id}>
            <a target="_blank" href={"/app/mapa/espacioydatos/default.aspx?ag=" + datos.UBICACION_GEOGRAFICA} id={"TituloHiper-0" + id}>
              <span className="goog-trans-section l tit-normal espacios" id={"gadget-" + id} onClick={() =>registradatos(datos.TITULO, "/app/mapa/espacioydatos/default.aspx?ag=" + datos.UBICACION_GEOGRAFICA, metodo)}> 
                {highlightTexto(datos.TITULO + " (" + datos.UBICACION_GEOGRAFICA +")")}    
              </span>
                <img src="/componentes/biinegi/img/icomapar.png" className="icoES" id="magen" alt="" />
            </a>
          </div>
          <div className="col-lg-12" id="responsivaAreas" > 
            <div className="row">
              <div className="col-lg-6"  style={{marginTop:"10px"}} id={"nivel1-" + id}>
                <img src={"/img/servicios/agmapas/" + datos.UBICACION_GEOGRAFICA + ".jpg"}  className="mx-auto imgMax" id={"img-" + id} alt="" />
              </div>
              <div className="col-xs-12 col-lg-6 col-sm-12 col-md-12 topAreas" id={"nivel2-" + id}>
                <div id={"nivel2-1-" + id} ref={(el) => (idrefCuadro.current[id] = el)}>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}
export default BuscadorAreasGeograficas;